var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"project__carousel-images"},_vm._l((_vm.imgs),function(img){return _c('div',{key:img.id,staticClass:"project__carousel--image-wrapper",class:{
      active: _vm.pos === img.id + 1,
    }},[_c('img',{staticClass:"project__carousel--image",attrs:{"src":_vm.assembleImagePath(img.fileName),"alt":"","srcset":_vm.assembleImagePath(img.fileName, '2x')}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }